import { Link } from "react-router-dom";

export const PortalNavButton = ({ testId }) => (
  <Link
    to="/login"
    data-testid={testId}
    title="Student Portal — sign in"
    className="inline-block rounded-md overflow-hidden border border-[#d4af37]/30 hover:border-[#d4af37] hover:-translate-y-0.5 transition-all"
  >
    <img src="/student-portal-button.png" alt="Student Portal — Your learning workspace. Sign in." className="h-10 w-auto block" />
  </Link>
);
